
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralNorth as ObiBeaconGeneralNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-north.js';
 
 
 

 
 export const ObiBeaconGeneralNorth = createComponent({
   react: React,
   tagName: 'obi-beacon-general-north',
   elementClass: ObiBeaconGeneralNorthElement,
   events: {
     
   }
  });
 
 